import { Link } from 'react-router-dom';

export default function PageHeader({
  badge = 'JARCon ApS',
  title,
  subtitle,
  breadcrumbs = [],
  ctaText,
  ctaLink = '/kontakt',
}) {
  return (
    <div className="relative -mt-20 min-[1200px]:-mt-[112px] pt-28 sm:pt-32 min-[1200px]:pt-40 pb-12 md:pb-16 bg-gradient-to-b from-[#0d1420] via-[#090e15] to-[#070b10] border-b border-slate-800 technical-grid overflow-hidden">
      {/* Precision grid lines & accent glow */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Breadcrumbs removed as requested */}

        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-3xl">
            {badge && (
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-cyan-950/60 border border-cyan-500/40 text-cyan-300 text-xs font-open-sans uppercase tracking-wider mb-3">
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400" />
                <span>{badge}</span>
              </div>
            )}
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-4 text-base sm:text-lg text-slate-300 font-sans leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>

          {ctaText && (
            <div className="shrink-0">
              <Link
                to={ctaLink}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-sm tracking-wide transition-all shadow-lg shadow-cyan-950/50 hover:shadow-cyan-500/20 active:scale-[0.98]"
              >
                <span>{ctaText}</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
